export abstract class IGroupConfig {
	abstract get permissions(): any[];
}
